import React from "react"
import { Box } from "@mui/material"

interface MainWrapperProps {
  children: React.ReactNode
}

export const MainWrapper: React.FC<MainWrapperProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100dvh",
        flexDirection: "column"
      }}
    >
      {children}
    </Box>
  )
}
